import { Link } from 'react-router-dom';
import { destinations } from '@/mocks/travelData';

export default function DestinationCards() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-2">
            热门旅行目的地
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            精选亚洲最受欢迎的度假胜地，开启您的梦想之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {destinations.map((dest) => (
            <Link
              key={dest.slug}
              to={`/article/${dest.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={dest.imageUrl}
                  alt={dest.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                    {dest.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {dest.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{dest.country}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {dest.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}